module.exports = __webpack_public_path__ + "img/language1.e4026574.png";